import { render, staticRenderFns } from "./ReferralTreeDialog.vue?vue&type=template&id=4387d1e2&scoped=true"
import script from "./ReferralTreeDialog.vue?vue&type=script&lang=js"
export * from "./ReferralTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./ReferralTreeDialog.vue?vue&type=style&index=0&id=4387d1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387d1e2",
  null
  
)

export default component.exports